import { useState, useEffect } from "react";
import {
    DataGridPremium
} from "@mui/x-data-grid-premium";
import classes from "../../Dashboard.module.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import AUTH_CONTEXT from "../../../../store";
import Loader from "../../../../components/Loader/Loader";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BASE_PATH_TO_HOME } from "../../../../base_routes_paths/data_paths";
import { DeviceURLServices } from "../../../../services/dashboard_services";
import CustomToolbar from "../../../../components/toolbar";
import { BASE_PATH_TO_ADD_DEVICE_URL } from "../../../../base_routes_paths/dashboard_paths";

const CurrentDeviceUrlsList = () => {
    const userColumns = [
        { field: "id", headerName: "ID", width: 230 },
        {
            field: "Key",
            headerName: "Key",
            width: 80,
        },
        {
            field: "location",
            headerName: "location",
            width: 120,
        },
        {
            field: "Value",
            headerName: "Link",
            width: 750,
            renderCell: (params) => {
                const link = params.row.Value;
                return (
                    <a href={link} target="_blank" rel="noopener noreferrer">
                        {link}
                    </a>
                );
            },
        },
        {
            field: "LabelText",
            headerName: "LabelText",
            width: 150,
        },
    ];

    const { token, fileName } = AUTH_CONTEXT();
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [data, setData] = useState([]);
    const EXPORT_FILENAME = `${fileName}_DeviceURLsList`;
    const navigate = useNavigate();

    const FetchApi = async () => {
        try {
            let response = await DeviceURLServices.getAllDeviceURL(token, navigate);
            if (response.status === 207) {
                return toast
                    .error(response.error, {
                        position: "bottom-left",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                    })
            }
            setIsDataFetched(true);

            let result = response.data.data;

            for (var i = 0; i < result.length; i++) {
                if (result[i].Key === 1) {
                    result[i].location = "Login Page";
                }
            }

            let input = result.map(({ _id: id, ...result }) => ({
                id,
                ...result,
            }));
            setData(input);
            toast.success("Data fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } catch (e) {
            setIsDataFetched(false);
            toast.error(e.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        if (!isDataFetched) {
            FetchApi();
        }
    }, []);

    const handleDelete = (id) => {
        DeviceURLServices.deleteDeviceURL(id, token);
    };

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => {
                return (
                    <div className={classes.cellAction}>
                        <div
                            className={classes.deleteButton}
                            onClick={() => handleDelete(params.row.Key)}
                        >
                            Delete
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <div>
            {isDataFetched && (
                <div className={classes.datatable}>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 1 }}>
                        <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                            Dashboard
                        </Link>
                        <Typography color="text.primary">
                            Dashboard
                        </Typography>
                        <Typography color="text.primary">Device URL's</Typography>
                    </Breadcrumbs>
                    <DataGridPremium
                        rows={data}
                        columns={userColumns.concat(actionColumn)}
                        slots={{
                            toolbar: () => (
                                <CustomToolbar
                                    EXPORT_FILENAME={EXPORT_FILENAME}
                                    onClickCreate={() => {
                                        navigate(BASE_PATH_TO_ADD_DEVICE_URL);
                                    }}
                                    displayCreate={""}
                                    onClickUpdate={() => { }}
                                    displayUpdate={"none"}
                                />
                            ),
                        }}
                        pagination
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 25, page: 0 },
                            },
                        }}
                        disableRowSelectionOnClick
                        checkboxSelection
                    />
                </div>
            )}
            {!isDataFetched && <Loader />}
        </div>
    );
};

export default CurrentDeviceUrlsList;
